import { render, staticRenderFns } from "./ValuationRequest.vue?vue&type=template&id=3b71b004&scoped=true&"
import script from "./ValuationRequest.vue?vue&type=script&lang=js&"
export * from "./ValuationRequest.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/index.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./ValuationRequest.vue?vue&type=style&index=1&id=3b71b004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71b004",
  null
  
)

/* custom blocks */
import block0 from "./ValuationRequest.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports